
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.57143 13.1112C8.57143 15.259 6.65265 17.0001 4.28571 17.0001C1.91878 17.0001 0 15.259 0 13.1112H8.57143Z"}}),_c('path',{attrs:{"d":"M20 13.1112C20 15.259 18.0812 17.0001 15.7142 17.0001C13.3473 17.0001 11.4285 15.259 11.4285 13.1112H20Z"}}),_c('path',{attrs:{"d":"M9.00585 3.63556V3H10.9942V3.63556H16.4041L20 12.5175V13.1111H18.0117V12.8958L15.731 7.26249L13.4503 12.8958V13.1111H11.462V12.5175L14.2626 5.6H10.9942V9.47111H9.00585V5.6H5.7374L8.53801 12.5175V13.1111H6.54971V12.8958L4.26901 7.26249L1.9883 12.8958V13.1111H0V12.5175L3.59593 3.63556H9.00585Z"}})])
          )
        }
      }
    